import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Modal,
  Select,
  Card,
  Button,
  Switch,
  Radio,
  Checkbox,
  Row,
  Col,
  Typography,

  Layout,
  Alert,
  message,
  Divider,
  Anchor,

} from 'antd';
// import { convert } from 'html-to-text';
import ConfluenceAliases from './aliases/alias_main';
import {
  getConfluenceSpaces,
  getConfluenceChannelConfig,
  addConfluenceChannelConfig,
  checkChannelConfigs,
  deleteConfluenceChannelConfig,
  getJiraCommonConfig,
  channelAdminConfig, // to turn off the auto create in the channel if auto suggest turned on
  getSkillId,
  getCustomEmojis,
} from '../skills_action';
import ConfluenceChannelAdmin from './confluence_channel_admins';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { emojis } from '../../../utils/slackemojis';
import EmojiPicker from '../../skills/jira/emojiPicker';
import RichTextEditor from '../cardSkill/richTextEditor';


const { Text, Title } = Typography;
const { Content } = Layout;
const { Option } = Select;
const { Link } = Anchor;
const matching_type_options = [
  { label: 'Loose', value: 'loose' },
  { label: 'Tight', value: 'tight' },
];
const matching_scope_options = [
  { label: 'Title, Label', value: 'title' },
  { label: 'Title, Label, Content', value: 'all' },
  { label: 'Label', value: 'label' },
];

const helpBehaviourInitialState = {
  enabled: false,
  emoji: ':man-raising-hand:',
};

const maxCharacterLimit = 256;



class ConfluenceCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      JiraCommonChannelConfig: {},
      config_spaces: [],
      visible: false,
      selected_spaces: [],
      auto_suggest: true,
      isKeywordSearchActive: true,
      showCreateButton: true,
      searchContent: false,
      searchBy: 'title',
      previousValues: [],
      restrictAccess: false,
      config: {},
      configLoading: false,
      channelType: '',
      noResultMessage: this.initalNoResultMessage, // This has the html content of the no result message for handling the hyperlinks
      noResultMessageModalVisible: false,
      customLabelsSearch: [],
      helpBehaviour: helpBehaviourInitialState,
      showChangeEmojiModal: false,
      auto_suggest_disable_if_message_with_emoji: {
        isEnabled: true,
        emoji: ':loudspeaker:',
      },
      openEmojiModal: false,
      showNoResultMessage: false,

      editorContent: this.initialContentState || '', // This has the raw format of the rich text editor. This is used to handle the line breaks (line breaks in html content will automatically removed by the editor)
      editorErrorMessage: '',
      customEmojisFromSlack: [],
    };
    this.openSettingModal = this.openSettingModal.bind(this);
  }
  initalNoResultMessage =
    '<p>Hey @@@user@@@, we do not have an answer right now. Do you want our team to look into this request?</p>';

  isHTMLString = (str) => {
    const htmlRegex = /<\/?[a-z][\s\S]*>/i;
    return htmlRegex.test(str);
  };

  // For handling non-html strings
  encloseWithPTags = (str) => {
    if (!this.isHTMLString(str)) {
      return `<p>${str}</p>`;
    }
    return str;
  };

  // generateContentState = (noResultMessage) => {
  //   noResultMessage = this.encloseWithPTags(noResultMessage);
  //   const initialBlocksFromHTML = convertFromHTML(noResultMessage);
  //   const editorContent = JSON.stringify(
  //     convertToRaw(
  //       ContentState.createFromBlockArray(
  //         initialBlocksFromHTML.contentBlocks,
  //         initialBlocksFromHTML.entityMap
  //       )
  //     )
  //   );
  //   return editorContent;
  // };

  // initialContentState = this.generateContentState(this.initalNoResultMessage);

  componentDidMount() {
    this.setState({ configLoading: true });
    this.getCommonConfigAndSave();
    this.props
      .getConfluenceChannelConfig(
        this.props.match.params.wId,
        this.props.channel.id
      )
      .then((res) => {
        if (res.data && res.data.success) {
          // this.setState({configLoading : false})
          let { config } = res.data;
          if (config === null) {
            checkChannelConfigs(this.props.match.params.wId, {
              requiredData: ['channel_sync'],
              channel_id: this.props.channel.id,
            }).then((res) => {
              if (res.success) {
                this.setState({ configLoading: false });
                if (res.channelMeta.channel_sync_present) {
                  message.error({
                    style: {
                      width: '60vw',
                      margin: 'auto',
                    },
                    content: (
                      <>
                        #{this.props.channel.name || 'This CHannel'} is
                        configured for channel sync. Delete the configuration
                        first before proceeding, To delete the channel sync
                        configuration, type '/t configure' in that channel and
                        click "Delete".
                      </>
                    ),
                  });
                  this.props.history.push(
                    `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}?view=channel_preferences`
                  );
                } else this.updateConfiguration(true);
              }
            });
            // this.updateConfiguration(true)
          } else if (config) {
            this.setState({ configLoading: false });
            let currentUser = this.props.user_now;
            let isChannelAdmin = true;

            if (this.props.isWorkspaceAdmin) {
              isChannelAdmin = true;
            } else {
              if (
                currentUser &&
                currentUser._id &&
                config.restrict_channel_config
              ) {
                let checkForAdmin =
                  config &&
                  config.channel_admins &&
                  config.channel_admins.find(
                    (el) =>
                      (el.user_id ? el.user_id.toString() : el.toString()) ===
                      currentUser._id.toString()
                  );
                if (checkForAdmin) {
                  isChannelAdmin = true;
                } else {
                  isChannelAdmin = false;
                }
              }
            }

            this.setState({
              // visible: false,
              auto_suggest: config.auto_suggest,
              isKeywordSearchActive: config.isKeywordSearchActive,
              searchContent: config.searchContent,
              searchBy: config.searchBy,
              showCreateButton: config.showCreateButton,
              config_spaces: config,
              selected_spaces: config.spaces || [],
              restrictAccess: !isChannelAdmin,
              config: config,
              channelType: config.channelType ? config.channelType : 'support',
              noResultMessage: this.encloseWithPTags(config.noResultMessage),
              customLabelsSearch: config.customLabelsSearch || [],
              helpBehaviour: config.helpBehaviour || helpBehaviourInitialState,
              showNoResultMessage: config.showNoResultMessage,
              editorContent: config.noResultMessage,

              // loading:false
            });

            if (config.auto_suggest_disable_if_message_with_emoji) {
              {
                this.setState((prevState) => ({
                  auto_suggest_disable_if_message_with_emoji: {
                    ...prevState.auto_suggest_disable_if_message_with_emoji,
                    isEnabled:
                      config.auto_suggest_disable_if_message_with_emoji
                        .isEnabled || false,
                    emoji:
                      config.auto_suggest_disable_if_message_with_emoji.emoji ||
                      ':loudspeaker:',
                  },
                }));
              }
            }
          }
        }
      });


    getCustomEmojis(this.props.match.params.wId).then((emojis) => {
      this.setState({
        customEmojisFromSlack: emojis,
      });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.noResultMessageModalVisible !==
      this.state.noResultMessageModalVisible
    ) {
      let editorState;
      if (this.state.editorContent) {
        editorState = this.state.editorContent
      } else {
        const generatedEditorContent = this.state.noResultMessage
        editorState = generatedEditorContent;
      }
      this.setState({ editorState });
    }
  }

  getCommonConfigAndSave = async () => {
    let resp = await getJiraCommonConfig(
      this.props.match.params.wId,
      this.props.match.params.skill_id,
      this.props.channel.id
    );
    this.setState({ JiraCommonChannelConfig: resp.data.commonConfig });
  };

  removeEmptyStrings(arr) {
    return arr.filter((str) => str !== '');
  }

  getIndividualLabels = (items, type) => {
    let output = [...this.state.customLabelsSearch];
    if (type === 'add') {
      let elArray = items.split(' ');
      output = [...output, ...elArray];
    } else if (type === 'remove') {
      output = output.filter((el) => el !== items);
    }


    let newOutput = this.removeEmptyStrings(output);

    return [...new Set(newOutput)];
  };

  openSettingModal() {
    this.props.getConfluenceSpaces(this.props.match.params.wId).then((res) => {
      const { config } = this.props;
      let _obj = {};
      if (config) {
        _obj = {
          showCreateButton: config.showCreateButton,
          isKeywordSearchActive: config.isKeywordSearchActive,
          searchContent: config.searchContent,
          searchBy: config.searchBy,
        };
        if (this.state.config.spaces) {
          _obj.config_spaces =
            this.state.config && this.state.config.spaces
              ? this.state.config.spaces.map((space) => space.id)
              : [];

          _obj.selected_spaces = Array.from(
            this.state.config && this.state.config.spaces
              ? this.state.config.spaces
              : []
          );

          _obj.previousValues = Array.from(
            this.state.config && this.state.config.spaces
              ? this.state.config.spaces
              : []
          );
        }
      }

      _obj.visible = true;
      this.setState(_obj);
    });
  }

  onJiraProjectTypeChange = (event) => {
    Modal.confirm({
      title: 'Confirm Project type',
      icon: <ExclamationCircleOutlined />,
      onOk: () => {
        const channelType = event.target.value === 1 ? 'project' : 'support';

        this.setState({ channelType }, () => this.updateConfiguration());
      },
      content: `Switching project will delete all preferences setup up earlier and create new preferences. This action is irreversible. Are you sure?`,
    });
  };
  handleOk = async () => {
    try {
      this.setState({
        loading: true,
      });

      const res = await this.props
        .addConfluenceChannelConfig(this.props.match.params.wId, {
          workspace_id: this.props.match.params.wId,
          channel: this.props.channel,
          spaces: this.state.selected_spaces,
          skill_id: this.props.match.params.skill_id,
        })
      if (res.data.success) {
        this.setState({
          visible: false,
          showCreateButton:
            res.data && res.data.config && res.data.config.showCreateButton,
          isKeywordSearchActive:
            res.data &&
            res.data.config &&
            res.data.config.isKeywordSearchActive,
          searchContent:
            res.data && res.data.config && res.data.config.searchContent,
          auto_suggest:
            res.data && res.data.config && res.data.config.auto_suggest,
          searchBy:
            res && res.data && res.data.config && res.data.config.searchBy,
          loading: false,
          config: res.data && res.data.config,
        });
      } else {
        this.setState({
          loading: false,
        });
        message.error(res?.data?.message, "Error creating channel configuration");
      }
    } catch (err) {
      this.setState({
        loading: false,
      });
      message.error(err?.message, "Error creating channel configuration");
    }
  };

  showErrorMessage() {
    let text = `Channel configuration access restricted. Contact one of the channel admins (or workspace admins) for access: ${this.getAdminNames()}`;
    return text;
  }

  updateConfiguration = async (addNewone) => {
    try {
      const entityRegex = /&[A-Za-z]+;/g; // Regex to remove HTML entities such as &nbsp;
      const newlineRegex = /[\n\t]/g; // Remove newline and tab characters

      const res = await this.props
        .addConfluenceChannelConfig(
          this.props.match.params.wId,
          {
            workspace_id: this.props.match.params.wId,
            channel: this.props.channel,
            showCreateButton: this.state.showCreateButton,
            isKeywordSearchActive: this.state.isKeywordSearchActive,
            searchContent: this.state.searchContent,
            searchBy: this.state.searchBy,
            auto_suggest: this.state.auto_suggest,
            skill_id: this.props.match.params.skill_id,
            channelType: this.state.channelType
              ? this.state.channelType
              : this.state.JiraCommonChannelConfig &&
              this.state.JiraCommonChannelConfig.channel_type,
            noResultMessage: this.state.noResultMessage
              .replace(entityRegex, '')
              .replace(newlineRegex, ''),
            noResultEditorContent: this.state.editorContent,
            customLabelsSearch: this.state.customLabelsSearch || [],
            helpBehaviour: this.state.helpBehaviour || helpBehaviourInitialState,
            auto_suggest_disable_if_message_with_emoji: {
              isEnabled:
                this.state.auto_suggest_disable_if_message_with_emoji.isEnabled,
              emoji: this.state.auto_suggest_disable_if_message_with_emoji.emoji,
            },
            showNoResultMessage: this.state.showNoResultMessage,
          },
          addNewone
        )
      if (res.data.success) {
        this.setState({
          config: res && res.data && res.data.config,
          channelType:
            res && res.data && res.data.config && res.data.config.channelType,
          noResultMessageModalVisible: false,
        });
      } else {
        message.error(res?.data?.message, "Error updating channel configuration");
      }
    } catch (error) {
      message.error(error?.message, "Error updating channel configuration");
    }
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
      selected_spaces: this.state.previousValues,
    });
  };
  onChangeSpaces = (event, data) => {
    this.setState({
      config_spaces: event,
      //   spaces:
    });
  };

  deleteChannelConfiguration = (channel_id, name) => {
    const channelFound = this.props.channels.find(
      (channel) => channel.id === channel_id
    );
    let isGridSharedChannel = false;
    if (
      channelFound &&
      channelFound.enterprise_id &&
      channelFound.is_org_shared
    )
      isGridSharedChannel = true;
    this.props
      .deleteConfluenceChannelConfig(
        this.props.match.params.wId,
        channel_id,
        this.props.match.params.skill_id,
        isGridSharedChannel
      )
      .then((res) => {
        if (res && res.data && res.data.success) {
          message.success(`#${name} configurations deleted successfully`);
          this.props.history.push(
            `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}?view=channel_preferences`
          );
        } else {
          message.error(`Error deleting #${name} configurations.`);
        }
      });
  };

  handleDeleteConfiguration = (data) => {
    const { channel_configs, user_now, isWorkspaceAdmin } = this.props;
    let isChannelAdmin = true;
    // const commondataFound = commonChanneldata.find(channelCommonData => channelCommonData.channel.id === data.id)
    const confluenceChannelData = channel_configs.find(
      (channeldata) => channeldata.channel.id === data.id
    );
    if (
      confluenceChannelData &&
      'restrict_channel_config' in confluenceChannelData &&
      confluenceChannelData.restrict_channel_config
    ) {
      const userFound =
        confluenceChannelData &&
        confluenceChannelData.channel_admins &&
        confluenceChannelData.channel_admins.find(
          (user) => user.toString() === user_now._id.toString()
        );
      if (userFound) isChannelAdmin = true;
      else isChannelAdmin = false;
    } else {
      isChannelAdmin = true;
    }

    if (isChannelAdmin || isWorkspaceAdmin) {
      return Modal.confirm({
        title: `Are you sure you want to delete channel configuration for this channel`,
        okText: 'Delete',
        okType: 'danger',
        onOk: () => this.deleteChannelConfiguration(data.id, data.name),
      });
    } else {
      return message.warning(
        `Channel configuration access restricted. Contact one of the channel admins (or workspace admins) for access: ${this.getAdminNames(
          confluenceChannelData
        )}`
      );
    }
  };

  addSpace = (val) => {
    // console.log("hello",this.state.selected_spaces,val)
    // let config_spaces=this.state.config_spaces
    let selected_spaces = this.state.selected_spaces;
    let exits = this.state.selected_spaces.find((space) => space.id == val);
    if (!exits) {
      //  console.log(this.props.spaces)
      let space = this.props.spaces.find((space) => space.id == val);

      selected_spaces.push(space);
      // console.log(config_spaces)
      this.setState({ selected_spaces });
    } else {
      this.setState({
        selected_spaces: selected_spaces.filter((space) => space.id != val),
      });
    }
    // selected_spaces
  };
  getAdminNames = () => {
    const { members, config } = this.props;

    let adiminNames = '';
    if (config && config.channel_admins) {
      config.channel_admins.forEach((id, index) => {
        if (index < 3) {
          const user = id;
          if (user)
            adiminNames = adiminNames + `${user.displayName || user.name} `;
        }
      });

      if (config && config.channel_admins && config.channel_admins.length > 3) {
        adiminNames =
          adiminNames + ` and ${config.channel_admins.length - 3} others`;
      }
    }

    return adiminNames;
  };

  goToChannel = () => {
    const { config } = this.props;
    const jiraSkill = this.props.skills.find((skill) => skill.name === 'Jira');

    if (!jiraSkill || !config) {
      return;
    }
    const { channel, channelType } = config;
    const subSkill =
      channelType === 'project' ? 'jira_software' : 'jira_service_desk';
    const view = 'channel_preferences';

    const skillId = jiraSkill.skill_metadata
      ? jiraSkill.skill_metadata._id
      : jiraSkill._id;
    this.props.history.push(
      `/${this.props.match.params.wId
      }/skills/${skillId}/${subSkill}?view=${view}&channel_name=${channel && channel.name
      }&channel_id=${channel && channel.id}&channel_type=${channelType}`
    );
  };

  removeSpace = (val) => {
    let selected_spaces = this.state.selected_spaces.filter(
      (space) => space.id != val
    );
    this.setState({ selected_spaces: selected_spaces });
  };

  handleNoResultModalCancel = () => {
    const { config } = this.props;
    this.setState({
      noResultMessageModalVisible: false,
      noResultMessage:
        config && config.noResultMessage
          ? this.encloseWithPTags(config.noResultMessage)
          : this.initalNoResultMessage,
      editorContent:
        config && config.noResultMessage
          ? config.noResultMessage
          : this.initialContentState,
    });
  };

  handleChangeEmojiInAutoSuggestDisableUsingEmoji = (emojiName) => {
    this.setState(
      (prevState) => ({
        openEmojiModal: false,
        auto_suggest_disable_if_message_with_emoji: {
          ...prevState.auto_suggest_disable_if_message_with_emoji,
          emoji: emojiName,
        },
      }),
      () => {
        this.updateConfiguration(false);
      }
    );
  };

  disableAutoSuggestWithEmoji = (value) => {
    this.setState(
      (prevState) => ({
        auto_suggest_disable_if_message_with_emoji: {
          ...prevState.auto_suggest_disable_if_message_with_emoji,
          isEnabled: value,
        },
      }),
      () => {
        this.updateConfiguration(false);
      }
    );
  };

  handleAutoSuggestTurnOnAndOff = (checked) => {
    this.setState({ auto_suggest: checked }, this.updateConfiguration);


  };

  handleContentStateChange = (contentState) => {

    this.setState({ noResultMessage: contentState });
  };

  handleEditorStateChange = (html) => {

    const plainText = html.replace(/<[^>]+>/g, '').trim(); // Remove HTML tags
    const { editorState } = this.state;

    if (plainText.length > maxCharacterLimit) {
      if (this.state.editorErrorMessage !== `Character limit (${maxCharacterLimit}) reached.`) {
        this.setState({ editorErrorMessage: `Character limit (${maxCharacterLimit}) reached.` });
      }
      return;
    }

    if (editorState !== html || this.state.editorErrorMessage) {

      this.setState({
        editorState: html,
        noResultMessage: html,

        editorErrorMessage: '',
      });
    }
  };



  handleBeforeInput = (chars) => {
    const currentContent = this.state.editorState.getCurrentContent();
    const currentContentPlainText = currentContent.getPlainText('');
    const currentContentLength = currentContentPlainText.length;

    if (currentContentLength + chars.length > maxCharacterLimit) {
      this.setState({
        editorErrorMessage: `Character limit (${maxCharacterLimit}) reached.`,
      });
      return 'handled';
    } else {
      this.setState({ editorErrorMessage: '' });
    }
    return 'not-handled';
  };

  extractTextFromEditorContent = (content) => {
    const contentWithNewlines = content.replace(
      /<br\s*\/?>|<p>\s*<\/p>/gi,
      '\n'
    );
    const tempElement = document.createElement('div');
    tempElement.innerHTML = contentWithNewlines;
    const extractedText = tempElement.textContent || tempElement.innerText;
    return extractedText;
  };

  handleResetEditor = () => {
    const editorState = this.initialContentState
    this.setState({
      editorContent: this.initialContentState,
      noResultMessage: this.initalNoResultMessage,
      editorState: editorState,
    });
  };

  checkInCustomEmojis = (customEmojisFromSlack, emoji) => {
    if (customEmojisFromSlack[emoji])
      return (
        <img
          style={{
            width: '22px',
            height: '22px',
          }}
          src={customEmojisFromSlack[emoji]}
          alt=''
        />
      );
  };

  render() {
    const { spaces, isWorkspaceAdmin, config } = this.props;
    const { selected_spaces } = this.state;
    const anchor_classname = localStorage.getItem('dark')
      ? 'anchor-links-dark'
      : 'anchor-links';

    const connectedSpacesText =
      selected_spaces && selected_spaces.length > 0
        ? selected_spaces.reduce((previousValue, currentValue) => {
          if (previousValue) {
            return previousValue + ',' + currentValue.name;
          } else {
            return currentValue.name;
          }
        }, '')
        : 'All Spaces';

    return (
      <Layout style={{ marginLeft: 0 }}>
        <>
          {/* <Alert
                    // description="Troopr is not invited to this channel. Features like Notifications, Reports, etc. will not work until Troopr is added. Use /invite @Troopr Assistant to invite Troopr to this channel."
                    message='Make sure Troopr is invited to this channel otherwise Confluence features will not work until Troopr is added. Use /invite @Troopr Assistant to invite Troopr to this channel.'
                    type='warning'
                    showIcon
                    style={{ width: "calc(100% - 16px)", maxWidth: 984 }}
                  /> */}
          {this.state.restrictAccess && (
            <Alert
              // description="Troopr is not invited to this channel. Features like Notifications, Reports, etc. will not work until Troopr is added. Use /invite @Troopr Assistant to invite Troopr to this channel."
              message={this.showErrorMessage() || 'Channel access restricted.'}
              type='warning'
              showIcon
              style={{ width: 'calc(100% - 16px)', maxWidth: 984 }}
            />
          )}
          <br />
        </>
        <Row style={{ width: '100%' }}>
          <Col span={20}>
            <Content className='site-layout-background'>
              <Row
                style={{ marginBottom: '80vh', marginLeft: 0, marginRight: 0 }}
                gutter={[16, 16]}
              >
                <Col
                  span={24}
                  style={{ display: 'flex' }}
                  id='confluencespaces'
                >
                  <Card
                    title='Confluence Spaces'
                    style={{ width: '100%' }}
                    extra={
                      <Button
                        disabled={this.state.restrictAccess}
                        onClick={this.openSettingModal}
                      >
                        Manage
                      </Button>
                    }
                    loading={this.state.configLoading}
                  >
                    <Text type='secondary'>
                      Configure Confluence spaces for this channel. Articles
                      from the configured spaces will be looked up for
                      suggestions for requests made in this channel.
                    </Text>
                    <br />
                    <br />
                    <Text bold>
                      Connected Spaces:{' '}
                      <Text type='secondary'>{connectedSpacesText}</Text>{' '}
                    </Text>

                    <br />
                    <br />
                  </Card>
                </Col>

                <Col span={24} style={{ display: 'flex' }} id='matchingoptions'>
                  <Card
                    title='Matching Options'
                    style={{ width: '100%' }}
                    // size="small"
                    loading={this.state.configLoading}
                  >
                    <Text type='secondary'>
                      Tune the Confluence search behaviour in this channel.
                    </Text>
                    <br />
                    <Divider />
                    <Title level={5}>Matching Type</Title>
                    <Text type='secondary'>
                      Use loose matching to find articles where any of the
                      keywords or phrases in the message match or use tight
                      matching type to match articles only when all keywords or
                      phrases match.
                    </Text>
                    <br />
                    <Radio.Group
                      options={matching_type_options}
                      disabled={this.state.restrictAccess}
                      onChange={(event) => {
                        let value = event.target.value;

                        this.setState(
                          {
                            isKeywordSearchActive:
                              value === 'loose' ? true : false,
                          },
                          this.updateConfiguration
                        );
                      }}
                      value={
                        this.state.isKeywordSearchActive ? 'loose' : 'tight'
                      }
                      optionType='button'
                      buttonStyle='solid'
                    />

                    <br />
                    <Divider />
                    <Title level={5}>Matching Scope</Title>
                    <Text type='secondary'>
                      Confluence pages will be found based on matches found in
                      selected fields of the page.
                    </Text>
                    <br />
                    <Radio.Group
                      options={matching_scope_options}
                      disabled={this.state.restrictAccess}
                      onChange={(event) => {
                        let value = event.target.value;
                        this.setState(
                          { searchBy: value },
                          this.updateConfiguration
                        );
                      }}
                      value={
                        this.state.searchBy
                          ? this.state.searchBy
                          : this.state.searchContent
                            ? 'all'
                            : 'title'
                      }
                      optionType='button'
                      buttonStyle='solid'
                    />
                    <br />
                    <Divider />
                    <Title level={5}>Matching Filter</Title>
                    <Text type='secondary'>
                      Show only matches from Confluence pages that have the
                      following labels on them
                    </Text>
                    <Select
                      placeholder='Defaults to no labels'
                      mode='tags'
                      style={{
                        width: '100%',
                      }}
                      // onChange={(items) =>
                      //   this.setState(
                      //     {
                      //       customLabelsSearch: this.getIndividualLabels(items),
                      //     },
                      //     this.updateConfiguration
                      //   )
                      // }
                      onSelect={(items) =>
                        this.setState(
                          {
                            customLabelsSearch: this.getIndividualLabels(
                              items,
                              'add'
                            ),
                          },
                          this.updateConfiguration
                        )
                      }
                      onDeselect={(items) =>
                        this.setState(
                          {
                            customLabelsSearch: this.getIndividualLabels(
                              items,
                              'remove'
                            ),
                          },
                          this.updateConfiguration
                        )
                      }
                      tokenSeparators={[',']}
                      value={this.state.customLabelsSearch}
                      options={(this.state.customLabelsSearch || []).map(
                        (item) => {
                          return {
                            value: item,
                            label: item,
                          };
                        }
                      )}
                    />
                    <br />
                  </Card>
                </Col>
                <Col span={24} style={{ display: 'flex' }} id='aliases'>
                  <ConfluenceAliases
                    restrictAccess={this.state.restrictAccess}
                    channel={this.props.channel}
                  />
                </Col>
                <Col span={24} id='noResultBehaviour'>
                  <Card
                    title='No results message'
                    key='1'
                    extra={
                      <Switch
                        checked={this.state.showNoResultMessage}
                        onClick={(checked, event) => {
                          event.stopPropagation();
                          this.setState(
                            { showNoResultMessage: checked },
                            this.updateConfiguration
                          );
                        }}
                      ></Switch>
                    }
                  >
                    <Text type='secondary'>
                      The following message will be sent when there are no
                      matching results from the connected Confluence space (only
                      when auto-suggest is enabled and atleast one of "Suggest
                      request creation", "Ask for help" is enabled).
                    </Text>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        marginTop: 16,
                      }}
                    >
                      <Text italic type='secondary'>
                        {config && config.noResultMessage
                          ? this.extractTextFromEditorContent(
                            config.noResultMessage
                          )
                          : this.extractTextFromEditorContent(
                            this.initalNoResultMessage
                          )}
                      </Text>
                      <div style={{ marginBottom: 8 }}>
                        <Button
                          onClick={() =>
                            this.setState({ noResultMessageModalVisible: true })
                          }
                          disabled={
                            this.state.restrictAccess ||
                            !this.state.showNoResultMessage
                          }
                        >
                          Customize
                        </Button>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col span={24} id='suggestticketcreation'>
                  <Card
                    title='Suggest Request creation'
                    key='1'
                    // size="small"
                    extra={
                      <Switch
                        checked={this.state.showCreateButton}
                        // defaultChecked
                        disabled={this.state.restrictAccess}
                        onClick={(checked, event) => {
                          event.stopPropagation();
                          this.setState(
                            { showCreateButton: checked },
                            this.updateConfiguration
                          );
                        }}
                      />
                    }
                  >
                    <Text type='secondary'>
                      Present option to create request in Jira when Confluence
                      suggestions does not resolve the request.
                    </Text>

                    <Modal
                      visible={this.state.noResultMessageModalVisible}
                      onCancel={() => this.handleNoResultModalCancel()}
                      onOk={() => this.updateConfiguration()}
                      title={
                        <>
                          Customize No results message{' '}
                          <Text type='secondary'>(Max 250 characters)</Text>
                        </>
                      }
                      maskClosable={false}
                      okText='Update'
                      footer={
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Button key='back' onClick={this.handleResetEditor}>
                            Reset
                          </Button>
                          <div>
                            <Button
                              key='cancel'
                              onClick={this.handleNoResultModalCancel}
                            >
                              Cancel
                            </Button>
                            <Button
                              key='update'
                              type='primary'
                              onClick={this.updateConfiguration}
                            >
                              Update
                            </Button>
                          </div>
                        </div>
                      }
                    >
                      <>
                        {/* <Input.TextArea
                          maxLength={250}
                          value={this.state.noResultMessage}
                          onChange={(e) =>
                            this.setState({ noResultMessage: e.target.value })
                          }
                        /> */}
                        <RichTextEditor
                          editorState={this.state.editorState}
                          handleEditorStateChange={this.handleEditorStateChange}
                          // handleContentStateChange={
                          //   this.handleContentStateChange
                          // }
                          errorMessage={this.state.editorErrorMessage}
                        // handleBeforeInput={this.handleBeforeInput}
                        />
                      </>
                    </Modal>
                    <Divider />
                    <div>
                      <div style={{ marginBottom: 8 }}>
                        <div>
                          <Text strong>Jira Project Type</Text>
                        </div>
                        <Text type='secondary'>
                          Choose the type of Jira project to use
                        </Text>
                      </div>
                      <div style={{ marginBottom: 8 }}>
                        <Radio.Group
                          value={this.state.channelType === 'project' ? 1 : 2}
                          onChange={this.onJiraProjectTypeChange}
                          disabled={
                            this.state.restrictAccess ||
                            !this.state.showCreateButton
                          }
                        >
                          <Radio value={1}>Use Jira Software project</Radio>
                          <Radio value={2}>
                            Use Jira Service Management project
                          </Radio>
                        </Radio.Group>
                      </div>
                      <div>
                        {/* http://localhost:3000/60b7130e4e6cc132ba0a990a/skills/60b7130e60cb173b7b4d3ac5/jira_service_desk?view=channel_preferences&channel_name=wikis-sssivaaa&channel_id=C03SJS6E99A&channel_type=support */}
                        <Button
                          disabled={
                            this.state.restrictAccess ||
                            !this.state.showCreateButton
                          }
                          onClick={this.goToChannel}
                        >
                          Customize
                        </Button>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col
                  style={{ display: 'flex', flexDirection: 'column' }}
                  span={24}
                  id='autosuggest'
                >
                  <Card
                    title='Auto Suggest'
                    key='1'
                    // size="small"
                    extra={
                      <>
                        <Switch
                          checked={this.state.auto_suggest}
                          disabled={this.state.restrictAccess}
                          // defaultChecked
                          onClick={(checked, event) => {
                            this.handleAutoSuggestTurnOnAndOff(checked);
                          }}
                        />
                      </>
                    }
                  >
                    <Text
                      style={{ display: 'flex', flexDirection: 'column' }}
                      type='secondary'
                    >
                      Automatically suggest matching articles for every message
                      in channel.
                      {this.state.auto_suggest && (
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <Checkbox
                            disabled={!this.state.auto_suggest}
                            style={{ marginTop: 10 }}
                            checked={
                              this.state
                                .auto_suggest_disable_if_message_with_emoji
                                .isEnabled
                            }
                            onChange={(value) => {
                              this.disableAutoSuggestWithEmoji(
                                value.target.checked
                              );
                            }}
                          >
                            Disable auto-suggest when message starts with{' '}
                            {emojis[
                              this.state
                                .auto_suggest_disable_if_message_with_emoji
                                .emoji
                            ] ||
                              this.checkInCustomEmojis(
                                this.state.customEmojisFromSlack,
                                this.state
                                  .auto_suggest_disable_if_message_with_emoji
                                  .emoji
                              )}{' '}
                            emoji
                          </Checkbox>
                          {this.state.auto_suggest_disable_if_message_with_emoji
                            .isEnabled && (
                              <a
                                style={{ marginTop: 10 }}
                                disabled={
                                  this.state.auto_suggest &&
                                  !this.state
                                    .auto_suggest_disable_if_message_with_emoji
                                    .isEnabled
                                }
                                onClick={() => {
                                  this.setState({
                                    openEmojiModal: true,
                                  });
                                }}
                              >
                                {' '}
                                (change emoji)
                              </a>
                            )}
                          {this.state.openEmojiModal && (
                            <EmojiPicker
                              handleClick={(el) => {
                                this.handleChangeEmojiInAutoSuggestDisableUsingEmoji(
                                  el.name
                                );
                              }}
                              customEmojisFromSlack={
                                this.state.customEmojisFromSlack
                              }
                              closePicker={() => {
                                this.setState({
                                  openEmojiModal: false,
                                });
                              }}
                            />
                          )}
                        </div>
                      )}
                    </Text>
                  </Card>
                </Col>
                <Col span={24} id='askForHelp'>
                  <Card
                    title='Ask for help behaviour'
                    key='1'
                    // size="small"
                    extra={
                      <Switch
                        checked={this.state.helpBehaviour.enabled}
                        disabled={this.state.restrictAccess}
                        onClick={(checked, event) => {
                          event.stopPropagation();
                          this.setState(
                            {
                              helpBehaviour: {
                                ...this.state.helpBehaviour,
                                enabled: checked,
                              },
                            },
                            this.updateConfiguration
                          );
                        }}
                      />
                    }
                  >
                    {this.state.showChangeEmojiModal && (
                      <EmojiPicker
                        customEmojisFromSlack={this.state.customEmojisFromSlack}
                        selectedEmoji={this.state.helpBehaviour.emoji}
                        closePicker={() => {
                          this.setState({ showChangeEmojiModal: false });
                        }}
                        handleClick={(el) => {
                          this.setState(
                            {
                              helpBehaviour: {
                                ...this.state.helpBehaviour,
                                emoji: el.name,
                              },
                            },
                            this.updateConfiguration
                          );
                          this.setState({ showChangeEmojiModal: false });
                        }}
                      />
                    )}
                    <Text type='secondary'>
                      When enabled, Troopr will show a "
                      {emojis[this.state.helpBehaviour.emoji] ||
                        this.checkInCustomEmojis(
                          this.state.customEmojisFromSlack,
                          this.state.helpBehaviour.emoji
                        )}{' '}
                      Ask for Help" button that will add a{' '}
                      {emojis[this.state.helpBehaviour.emoji] ||
                        this.checkInCustomEmojis(
                          this.state.customEmojisFromSlack,
                          this.state.helpBehaviour.emoji
                        )}{' '}
                      emoji (
                      <a
                        onClick={() =>
                          this.setState({ showChangeEmojiModal: true })
                        }
                        disabled={this.state.restrictAccess}
                      >
                        change emoji
                      </a>
                      ) to the request message in the main channel.
                    </Text>
                  </Card>
                </Col>
                {this.state.config && this.state.config._id && (
                  <Col id='channel_admins' span={24}>
                    <ConfluenceChannelAdmin
                      disabled={this.state.restrictAccess}
                      config={this.state.config}
                      isWorkspaceAdmin={isWorkspaceAdmin}
                    />
                  </Col>
                )}
                <Col id='delete_config' span={24}>
                  <Card title='Delete Channel Configuration'>
                    <Text type='secondary'>
                      Delete all configurations in this channel. This change is
                      irreversible.
                    </Text>
                    <br />
                    <br />
                    <Button
                      // type='primary'
                      danger
                      style={{
                        marginLeft: 'auto',
                        paddingRight: '8px',
                        marginTop: '15px',
                        marginRight: '7px',
                      }}
                      onClick={() =>
                        this.handleDeleteConfiguration(config.channel)
                      }
                    >
                      Delete Channel Configuration
                    </Button>
                  </Card>
                </Col>
              </Row>
            </Content>
          </Col>
          <Col span={4}>
            <Anchor
              getContainer={() =>
                document.getElementById('anchor-scroll-content')
              }
              style={{ marginRight: '16px' }}
            >
              <Link
                href='#confluencespaces'
                className={anchor_classname}
                title='Confluence Spaces'
              />
              <Link
                href='#matchingoptions'
                className={anchor_classname}
                title='Matching Options'
              />
              <Link
                href='#aliases'
                className={anchor_classname}
                title='Aliases'
              />
              <Link
                href='#noResultBehaviour'
                className={anchor_classname}
                title='No results message'
              />
              <Link
                href='#suggestticketcreation'
                className={anchor_classname}
                title='Suggest Request Creation'
              />
              <Link
                href='#autosuggest'
                className={anchor_classname}
                title='Auto Suggest'
              />
              <Link
                href='#askForHelp'
                className={anchor_classname}
                title='Ask for help behaviour'
              />
              <Link
                href='#channel_admins'
                className={anchor_classname}
                title='Restrict Channel configuration'
              />
              <Link
                href='#delete_config'
                className={anchor_classname}
                title='Delete Channel Configuration'
              />
            </Anchor>
          </Col>
        </Row>
        <Modal
          maskClosable={false}
          title='Spaces'
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText={'Submit'}
          confirmloading={this.state.loading}
        >
          <b>Select spaces</b>
          <Select
            mode='multiple'
            placeholder='Select a value'
            style={{ width: '100%' }}
            value={this.state.config_spaces}
            // defaultValue={this.state.fieldSelectedCompact && this.state.fieldSelectedCompact.field.name}
            //   onChange={this.onChangeSpaces}
            // placeholder="Select Spaces"
            optionFilterProp='children'
            // labelInValue={true}
            showSearch={true}
            onChange={(value, data) =>
              this.onChangeSpaces(value, data, 'labels')
            }
            onSelect={this.addSpace}
            onDeselect={this.removeSpace}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {spaces.map((space) => {
              return (
                <Option key={space.key} value={space.id}>
                  {space.name}
                </Option>
              );
            })}
          </Select>
          <br />
          <br />
        </Modal>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.skills.confluence_channel_config,
    spaces: state.skills.confluence_spaces,
    isWorkspaceAdmin: state.common_reducer.isAdmin,

    user_now: state.common_reducer.user,
    channels: state.skills.channels,
    commonChanneldata: state.skills.commonChanneldata,
    channel_configs: state.skills.confluence_channel_configs,
    skills: state.skills.skills,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getConfluenceSpaces,
    getConfluenceChannelConfig,
    addConfluenceChannelConfig,
    deleteConfluenceChannelConfig,
    channelAdminConfig,
    getSkillId,
  })(ConfluenceCard)
);
